// extracted by mini-css-extract-plugin
module.exports = {"courseListRoot":"Dashboard_courseListRoot__2txbU","cardsRow":"Dashboard_cardsRow__14g7e"};